<template>
  <!-- 重新雇佣 -->
  <div class="detail">
    <!-- 重新雇佣header -->
    <ax-panel :noTitle="true">
      <div class="header">
        <div>
          <span class="name">{{ dataDecrypt.header.name }}</span>
          <span class="tag">
            <van-tag color="#999999" text-color="#ffffff">司龄 {{ dataDecrypt.header.company_age }}年</van-tag>
          </span>
        </div>
      </div>
      <div>
        <van-cell title="离职原因">
          <span class="leave_tag">
            <van-tag color="#cccccc" text-color="#ffffff">{{ dataDecrypt.header.action }}/{{
      dataDecrypt.header.action_reason
    }}</van-tag>
          </span>
        </van-cell>
      </div>
    </ax-panel>
    <!-- 离职原因  -->
    <ax-panel :noTitle="true">
      <van-tabs v-model="active" color="#cccccc">
        <van-tab title="离职前信息">
          <van-cell title="离职日期" :value="dataDecrypt.header.termination_dt"></van-cell>
          <van-cell title="部门" :value="dataDecrypt.header.dept_descr"></van-cell>
          <van-cell title="岗位" :value="dataDecrypt.header.posn_descr"></van-cell>
          <van-cell title="直接上级" :value="dataDecrypt.header.supervisor2"></van-cell>
          <van-cell v-if="dataDecrypt.header.major_level" title="专业层级"
            :value="dataDecrypt.header.major_level"></van-cell>
          <van-cell v-if="dataDecrypt.header.jobmanager_level" title="管理层级"
            :value="dataDecrypt.header.jobmanager_level"></van-cell>
        </van-tab>
        <van-tab title="重新雇佣信息">
          <van-cell title="入职日期" :value="dataDecrypt.header.rehire_dt"></van-cell>
          <van-cell title="部门" :value="dataDecrypt.header.dept_descr2"></van-cell>
          <van-cell title="岗位" :value="dataDecrypt.header.posn_descr2"></van-cell>
          <van-cell title="直接上级" :value="dataDecrypt.header.supervisor"></van-cell>
          <van-cell v-if="dataDecrypt.header.major_level2" title="专业层级"
            :value="dataDecrypt.header.major_level2"></van-cell>
          <van-cell v-if="dataDecrypt.header.jobmanager_level2" title="管理层级"
            :value="dataDecrypt.header.jobmanager_level2"></van-cell>
        </van-tab>
      </van-tabs>
    </ax-panel>
    <!-- :noTitle="true"  -->
    <!-- 其他相关信息  -->
    <ax-panel title="其他相关信息">
      <van-cell title="离职时长" :value="dataDecrypt.header.resign_duration"></van-cell>
      <van-cell title="离职前薪资总包" :value="dataDecrypt.header.pay_sum_bf"></van-cell>
      <van-cell title="绩效成绩" :value="dataDecrypt.header.performance_score"></van-cell>
      <van-cell title="薪资涨幅" :value="dataDecrypt.header.salary_increase"></van-cell>
      <van-cell title="离职前HRBP" :value="dataDecrypt.header.hrbp"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_compt_flag != '否'" title="是否竞业"
        :value="dataDecrypt.header.is_compt_flag"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_compt_flag != '否' && dataDecrypt.header.compt_end_dt" title="竞业截止日期"
        :value="dataDecrypt.header.compt_end_dt"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_severancepkg != '否'" title="是否离职补偿"
        :value="dataDecrypt.header.is_severancepkg"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_severancepkg != '否' && dataDecrypt.header.severancepkg_my" title="离职补偿金额"
        :value="dataDecrypt.header.severancepkg_my"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_blacklist != '否'" title="是否黑名单"
        :value="dataDecrypt.header.is_blacklist"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_blacklist != '否' && dataDecrypt.header.blacklist_descr" title="黑名单描述"
        :value="dataDecrypt.header.blacklist_descr"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_viol_regul != '否'" title="是否违规"
        :value="dataDecrypt.header.is_viol_regul"></van-cell>
      <van-cell v-if="dataDecrypt.header.is_viol_regul != '否' && dataDecrypt.header.viol_regul_descr" title="违规描述"
        :value="dataDecrypt.header.viol_regul_descr"></van-cell>
      <!-- <van-cell title="审批意见" :value="dataDecrypt.header.reh_result"></van-cell> -->
    </ax-panel>
    <!-- 附件 -->
    <!-- <template v-if="item.type === 'p'">
      <p>{{ item.content }}</p>
    </template>
<template v-else-if="item.type === 'div'">
      <div>{{ item.content }}</div>
    </template> -->
    <!-- <ax-panel title="附件">
      <ax-down v-for="(fileItem, index) in dataDecrypt.qh_abs_004_atta" type="ssc" :data="{ fileName: fileItem.filename }"
        :key="index">
        <router-link slot="fileName" class="link_a" :to="{
      name: 'fileImg',
      query: {
        ...$route.query,
        attachsysfilename: fileItem.attachsysfilename, // 附件唯一名称
        emplid: dataDecrypt.header.emplid, // 员工编号
        action_dt_ss: dataDecrypt.header.action_dt_ss, // 提交时间
        effseq: dataDecrypt.header.effseq, // 生效序号
        path: $route.query.pageId
      }
    }">{{ fileItem.filename }}</router-link>
        <a class="item_content_val link_a" slot="right">
          <van-icon name="arrow" />
        </a>
      </ax-down>
    </ax-panel> -->
    <!-- 特批备注 -->
    <ax-panel
      :noTitle="true"
      v-if="dataDecrypt.header.qh_is_spaprpass === 'Y'"
    >
      <van-cell title="特批流程审批状态" >通过</van-cell>
      <van-cell>
        <p class="title">特批备注</p>
        <p class="desc">{{ dataDecrypt.header.qh_spcappr_note }}</p>
      </van-cell>
    </ax-panel>
    <!-- 审批意见下拉选择 -->
    <ax-panel :noTitle="true">
      <van-cell v-if="!action" title="审批结果" :value="getResultDesc(dataDecrypt.header.reh_result)"></van-cell>
      <van-cell v-if="action" is-link :value="dataDecrypt.resultValue" @click="isResult = true">
        <template #title>
          <span style="color:red">*&nbsp;</span>
          <span class="custom-title">审批结果</span>
          <!-- qh_hr_011_head.checked -->
        </template>
      </van-cell>
      <van-popup v-model="isResult" position="bottom" :style="{ height: '30%' }">
        <van-picker show-toolbar :columns="resultActions" @confirm="onResultSelect" @cancel="isResult=false" />
      </van-popup>
    </ax-panel>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import watermark from '../../utils/warterMark';
export default {
  props: ['data', 'pageObj', 'comments'],
  data() {
    return {
      active: '离职前信息',
      dataDecrypt: {
        reh_result: '',
        resultValue: '',
        header: {},
        field_special_deal: {}
      },
      action: true,
      isResult: false,
      resultActions: [
        { text: '符合重新雇佣原则', code: 'A' },
        { text: '不符合重新雇佣原则，可以申请特批', code: 'B' },
        { text: '不符合重新雇佣原则，且不得申请特批', code: 'C' },
      ],
    };
  },
  watch: {
    data() {
      this.dataDecrypt = JSON.parse(this.Decrypt(this.data));
      console.log(this.dataDecrypt);
      this.$emit('reciveData', this.dataDecrypt);
      this.action = this.dataDecrypt.action === 'U';
    }
  },
  mounted() { },
  methods: {
    Decrypt(word) {
      //数据解密
      const key = CryptoJS.enc.Utf8.parse('A-16-Byte-keyVal');
      const iv = CryptoJS.enc.Utf8.parse('A-16-Byte-String');

      let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
      let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      let decrypt = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    },
    // 审批选择
    onResultSelect(item) {
      this.isResult = false;
      this.dataDecrypt.resultValue = item.text;
      this.dataDecrypt.reh_result = item.code;
    },
    getResultDesc(code) {
      let item = this.resultActions.find(i => i.code == code)
      if (item) {
        return item.text;
      } else {
        return '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  background: #ffffff;
  padding: 15px 15px 15px 15px;
  border-bottom: 1px solid $border-color;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
  font-weight: 500;
  line-height: 18px;
  position: relative;

  .name {
    font-size: 18px;
    color: #000000;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 5px;
    margin-right: 10px;
  }

  .tag {
    position: absolute;
  }
}

.leave_tag {
  margin-right: 5px
}

.reason {
  font-size: 14px;
  padding: 15px 0 15px 15px;
}

.reason1 {
  font-size: 14px;
  padding: 5px 0 0px 5px;
  color: rgba(0, 0, 0, 0.3);
}

.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}

.van-cell {
  border-bottom: 1px solid $border-color;
}

.base {
  border-bottom: none;
}

.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}

.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}

.w100 .van-cell__title {
  width: 8rem;
}

.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}

.title {
  color: rgba(0, 0, 0, 0.3);
  // color: #000;
  font-size: 0.4rem;
  text-align: left;
  padding-left: 0.42667rem;
}

.title{
  color: rgba(0, 0, 0, 0.3);
  font-size: 0.4rem;
  padding-left: 0.42667rem;
  text-align: left;
  margin-bottom: 10px;
}
.desc {
  color: #000000;
  padding-left: 25px;
  font-size: 0.35rem;
  text-align: left;
}
</style>